import {
    Component,
    ComponentRef,
    Input,
    OnChanges,
    OnInit,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { ActionButtonComponent } from "@components/action-button/action-button.component";
import { MassupdateArbetsordrarComponent } from "~app/common/components/massupdate-arbetsordrar/massupdate-arbetsordrar.component";
import { RaskModalService } from "~app/common/components/modal/rask-modal.service";
import { AuthenticationService } from "~app/common/services/authentication/authentication.service";
import { IArbetsorder } from "~app/features/planera/model/IArbetsorder";
import { DomService } from "../../../../common/services/dom.service";
import { MasshanteringArbetsorderViewModel } from "./arbetsorder-masshantering.models";
import { ArbetsorderMasshanteringDialogComponent } from "./masshantering-dialog/arbetsorder-masshantering-dialog.component";

@Component({
    selector: "rask-arbetsorder-masshantering",
    templateUrl: "./arbetsorder-masshantering.component.html",
    styleUrls: ["./arbetsorder-masshantering.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [ActionButtonComponent]
})
export class ArbetsorderMasshanteringComponent implements OnInit, OnChanges  {
    cmp: ComponentRef<any>;
    @Input() data: IArbetsorder[];
    hasData = false;
    instance: MassupdateArbetsordrarComponent = null;
    viewModel: MasshanteringArbetsorderViewModel;

    private readonly authenticationService = inject(AuthenticationService);
    private readonly domService = inject(DomService);
    private readonly raskModalService = inject(RaskModalService);

    private canEdit: boolean;

    get masshanteraEnabled(): boolean {
        return this.canEdit && this.hasData;
    }

    get updateEnabled(): boolean {
        return this.canEdit && this.hasData && this.data.length <= 1000;
    }

    ngOnChanges(): void {
        this.init();
    }

    ngOnInit(): void {
        this.canEdit = this.authenticationService.canEdit();
        this.init();
    }

    protected openMasshanteraDialog() {
        this.raskModalService.open(
            "Masshantera arbetsorder",
            ArbetsorderMasshanteringDialogComponent,
            "xl",
            true,
            this.viewModel,
            "ao-masshantering-size");
    }

    protected updateDestineringsalternativ() {
        this.addComponentToBody();
        this.instance.header = "Uppdaterar destineringsalternativ";
        this.instance.arbetsordrar = this.data;

        setTimeout(() => {
            this.instance.uppdateraDestineringsalternativ();
        },1000);
    }

    protected uppdateraVirkesordrar() {
        const arbetsordrarAttUppdatera = this.data.filter(x => x.raskVo);

        if (arbetsordrarAttUppdatera.length === 0) {
            return;
        }
        this.addComponentToBody();
        this.instance.header = "Uppdaterar från regelverk";
        this.instance.arbetsordrar = arbetsordrarAttUppdatera;

        setTimeout(() => {
            this.instance.uppdateraVirkesordrar();
        },1000);
    }

    private addComponentToBody() {
        this.cmp = this.domService.appendComponentToBody(MassupdateArbetsordrarComponent);
        this.instance = this.cmp.instance;
        this.instance.cmp = this.cmp;
    }

    private init(): void {
        this.hasData = this.data?.length > 0;

        if (!this.hasData) {
            return;
        }

        this.viewModel = new MasshanteringArbetsorderViewModel(this.data);
    }
}
